<template>
  <WdwDynbox title="Eigene Beiträge" :config="{ showControls: true }">
    <template v-if="thoughtsLoading">
      <vue-loading loadingMessage="Beiträge werden geladen..." />
    </template>

    <div v-if="thoughtsFound">
      <div v-for="ownerThought in ownerThoughtList" v-bind:key="ownerThought.id" class="text-body">
        <p class="title" v-if="ownerThought.title" v-dompurify-html="ownerThought.title"></p>
        <p class="date">{{ thoughtDateAndId(ownerThought) }}</p>
        <p
          class="content-teaser"
          v-dompurify-html="ownerThought.content.substring(0, 200) + trippleDots(ownerThought.content)"
        ></p>

        <div class="icons small">
          <vote-stats-short :thought="ownerThought" />
        </div>
        <a :href="ownerThought.links.external_show_uri.href" class="link">- Zum Beitrag</a>
        <div>
          <a :href="ownerThought.topic.links.external_show_uri.href" class="link">- {{ topicGoTo() }}</a>
        </div>
      </div>
    </div>
    <div v-if="noThoughtsFound">
      <p>Keine Beiträge gefunden</p>
    </div>
    <Paginator :rows="3" :totalRecords="totalThoughtCount" @page="onPageChange($event)" />
  </WdwDynbox>
</template>

<script>
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { ref, toRefs } from '@vue/reactivity';
import thoughtRepository from '@/api/thoughtRepository';
import { computed, onBeforeMount, render } from 'vue';
import Paginator from 'primevue/paginator';
import VueLoading from '@/components/general/Loading.vue';
import VoteStatsShort from '@/components/discuss/thought/VoteStatsShort.vue';
import useTopicTerm from '@/composables/topic/useTopicTerm';
import useConverter from '@/composables/general/useConverter';
// TODO -> fully implement

export default {
  name: 'OwnerThoughtList',
  props: {
    user: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    //variables
    const { user, config } = toRefs(props);
    const ownerThoughtList = ref([]);
    const thoughtsLoading = ref(true);
    const isFetching = ref(true);
    const pager = ref({});
    const rows = 3;

    // Composables
    const { topicGoTo } = useTopicTerm();
    const { formattedDate, UTCtoLocalTime } = useConverter();

    //Computed
    const noThoughtsFound = computed(() => {
      return !thoughtsLoading.value && ownerThoughtList.value.length == 0;
    });

    const totalThoughtCount = computed(() => {
      return pager.value.total_entries / rows;
    });

    const thoughtsFound = computed(() => {
      return ownerThoughtList.value.length > 0 && !thoughtsLoading.value;
    });

    //Functions
    function loadOwnerThoughtList(pageNummber) {
      thoughtsLoading.value = true;
      const params = { ownerid: user.value.id, rows: rows, page: pageNummber, sort: '-created' };
      thoughtRepository
        .get(params)
        .then(resp => {
          pager.value = resp.pager;
          ownerThoughtList.value = resp.data;
          thoughtsLoading.value = false;
        })
        .catch(error => {
          console.log(error);
          thoughtsLoading.value = false;
        });
    }
    const trippleDots = content => {
      return content.length > 200 ? '... ' : '';
    };
    function onPageChange(event) {
      loadOwnerThoughtList(event.page + 1);
    }

    function openThoughtInNewTab(thoughtId, topicId) {
      const selected = ownerThoughtList.value.filter(e => e.id == thoughtId && e.topic.id == topicId);
      if (selected.length > 0) {
        return window.open(selected[0].show_uri_email_as_deeplink);
      } else {
        console.log(`openThoughtInNewTab called but no thought found to open for user. 
        userid: ${user.value.id}, 
        thoughtid: ${thoughtId}, 
        topicid: ${topicId}`);
      }
    }
    const thoughtDateAndId = thought => {
      const datetime = formattedDate(UTCtoLocalTime(thought.created));
      return datetime + ', Beitrag Nr. ' + thought.number;
    };
    //Life Cycle hooks
    onBeforeMount(() => {
      loadOwnerThoughtList(1);
    });
    return {
      //-----------------VARS------------------
      totalThoughtCount,
      ownerThoughtList,
      thoughtsLoading,
      noThoughtsFound,
      thoughtsFound,
      isFetching,
      thoughtDateAndId,
      //-----------------FUNCTION--------------
      openThoughtInNewTab,
      loadOwnerThoughtList,
      onPageChange,
      trippleDots,
      topicGoTo,
    };
  },

  components: {
    Paginator,
    WdwDynbox,
    VoteStatsShort,
    VueLoading,
  },
};
</script>

<style scoped>
.loading {
  margin: 15px 0px;
}
.title {
  margin-bottom: 0;
  font-size: 1.6rem;
  color: var(--wdw-primary-color);
}
.date {
  font-size: 0.85rem;
}
.content-teaser {
  font-size: 1.1rem;
}
.text-body {
  padding: 15px 10px;
  border-bottom: 1px solid #ccc;
}
.icons {
  margin-bottom: 10px;
}
</style>
